/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MembershipPolicyFeesInput { 
    id?: number;
    isRegistrationFee?: boolean;
    chargesId?: number | null;
    amount?: number | null;
    isSubscriptionFee?: boolean;
    subscriptionChargesId?: number | null;
    frequencyType?: string | null;
    subscriptionAmount?: number | null;
    isAppliedToExistingMembers?: boolean | null;
    isApplicableToMigratedMembers?: boolean;
    isDeleted?: boolean;
    isAutoDebitEnabled?: boolean;
}

